import React, { useEffect, useState } from "react";
import { Container, Card, Form, Button, Spinner, Alert } from "react-bootstrap";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import PageLayout from "../../../layouts/PageLayout";
import axios from "axios";

const TermsConditionsPage = () => {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [errors, setErrors] = useState({});

    const HARDCODED_TITLE = "Terms & Conditions";
    const PAGE_SLUG = "terms-conditions";
    const [content, setContent] = useState("");

    const quillModules = {
        toolbar: [
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ size: ["small", false, "large", "huge"] }],
            ["bold", "italic", "underline", "strike", "blockquote"],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link", "clean"],
        ],
    };

    const getAuthHeaders = () => ({
        Authorization: `Bearer ${localStorage.getItem("authToken") || ""}`,
    });

    const fetchPageData = async () => {
        try {
            setLoading(true);
            setError("");
            const res = await axios.get(
                `${process.env.REACT_APP_API_URL}/web-manager/pages/${PAGE_SLUG}`,
                { headers: getAuthHeaders() }
            );
            if (res.data?.data) {
                setContent(res.data.data.content || "");
            }
        } catch (err) {
            if (err.response?.status !== 404) {
                setError(err.response?.data?.message || "Failed to load page.");
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPageData();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");
        setError("");
        setErrors({});

        try {
            setSaving(true);
            const res = await axios.post(
                `${process.env.REACT_APP_API_URL}/web-manager/${PAGE_SLUG}`,
                { title: HARDCODED_TITLE, content },
                { headers: getAuthHeaders() }
            );
            setMessage(res.data?.message || "Saved successfully.");
        } catch (err) {
            if (err.response?.status === 422) {
                setErrors(err.response.data.errors || {});
            } else {
                setError(err.response?.data?.message || "Failed to save.");
            }
        } finally {
            setSaving(false);
        }
    };

    return (
        <PageLayout>
            <Container fluid className="py-4">
                <h2 className="fw-bold mb-1">{HARDCODED_TITLE} Settings</h2>
                <p className="text-muted mb-4">Manage legal terms and platform guidelines.</p>

                {message && <Alert variant="success" dismissible onClose={() => setMessage("")}>{message}</Alert>}
                {error && <Alert variant="danger" dismissible onClose={() => setError("")}>{error}</Alert>}

                {loading ? (
                    <div className="text-center py-5"><Spinner animation="border" /></div>
                ) : (
                    <Form onSubmit={handleSubmit}>
                        <Card className="border-0 shadow-sm mb-4">
                            <Card.Header className="bg-white py-3 fw-bold border-0">Editor</Card.Header>
                            <Card.Body>
                                <ReactQuill
                                    theme="snow"
                                    value={content}
                                    onChange={(val) => { setContent(val); setErrors({}); }}
                                    modules={quillModules}
                                    style={{ minHeight: "320px" }}
                                />
                                {errors.content && <div className="text-danger small mt-2">{errors.content[0]}</div>}
                            </Card.Body>
                        </Card>
                        <div className="d-flex justify-content-end">
                            <Button type="submit" variant="primary" disabled={saving} className="px-5 py-2 fw-semibold text-uppercase">
                                {saving ? <Spinner animation="border" size="sm" /> : "Save Terms & Conditions"}
                            </Button>
                        </div>
                    </Form>
                )}
            </Container>
        </PageLayout>
    );
};

export default TermsConditionsPage;